import { useEffect, useRef, useState } from "react";

export default function BackToRootsSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.05 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-background">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[600px] md:min-h-screen">
        <div className={`relative overflow-hidden transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}`}>
          <img 
            src="https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/bcbc044c7_vertical-shot-small-stream-water-flowing-through-autumn-forested-area-misty-day.jpg"
            alt="Back to the roots - reconnect with nature"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>

        <div className={`px-8 md:px-16 py-16 md:py-0 flex flex-col justify-center transition-all duration-700 ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`} style={{ transitionDelay: "80ms" }}>
          <div>
            <h2 className="font-heading text-4xl md:text-5xl font-light leading-[1.2] mb-6 text-foreground">
              Back to the roots.
              <br />
              <span className="italic">Let's reconnect with our nature.</span>
            </h2>
            <p className="font-body text-2xl leading-relaxed text-foreground/70 mb-8">
              Vi lever i en verden som går fort hele tiden. LYKKE NOMAD ble skapt for å bygge noe som skaper verdi, både for oss og kundene våre. Et sted hvor man kan ta en liten pause fra alt det. Den pausen finner vi i badstuen. Et sted hvor man kan roe ned, koble av og komme litt nærmere naturen igjen. Det tror vi egentlig at alle trenger litt mer av.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}